import OTPForm from "../../components/authentication/OTPForm";
import LoginForm from "../../components/authentication/LoginForm";
import useUserCredentials from "../../utils/hooks/user/useUserCredentials";
import { LoginStatus } from "../../utils/store/reducer/slices/userReducer";
import { Navigate, useLocation } from "react-router-dom";
import usePageTitle from "../../utils/hooks/usePageTitle";

/**
 * Allows the user to enter their login credentials and get authenticated.
 * Also lets them enter 2FA codes if applicable.
 *
 */
const LoginPage = () => {
  const location = useLocation();
  const { loginStatus } = useUserCredentials();
  usePageTitle("Login");

  return (
    <>
      {loginStatus === LoginStatus.SIGNED_OUT ? (
        <LoginForm />
      ) : loginStatus === LoginStatus.OTP_PENDING ? (
        <OTPForm />
      ) : (
        <Navigate to={location.state?.from?.pathname || "/"} />
      )}
    </>
  );
};

export default LoginPage;
